/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 6L13 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 18L16 12L13 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M14.8686 10.8686C15.2646 11.2646 15.4627 11.4627 15.5368 11.691C15.6021 11.8918 15.6021 12.1082 15.5368 12.309C15.4627 12.5373 15.2646 12.7354 14.8686 13.1314L11.7314 16.2686C10.8746 17.1254 10.4462 17.5538 10.0785 17.5827C9.75934 17.6078 9.44749 17.4786 9.23959 17.2352C9 16.9547 9 16.3489 9 15.1373L9 8.86274C9 7.65111 9 7.04529 9.23959 6.76477C9.44749 6.52136 9.75934 6.39218 10.0785 6.4173C10.4462 6.44624 10.8746 6.87462 11.7314 7.73137L14.8686 10.8686Z"
				fill="currentColor"
			/>
			<path
				d="M14.8686 10.8685C15.2646 11.2645 15.4627 11.4625 15.5368 11.6909C15.6021 11.8917 15.6021 12.1081 15.5368 12.3089C15.4627 12.5372 15.2646 12.7352 14.8686 13.1312L11.7314 16.2685C10.8746 17.1253 10.4462 17.5536 10.0785 17.5826C9.75934 17.6077 9.44749 17.4785 9.23959 17.2351C9 16.9546 9 16.3488 9 15.1371L9 8.86262C9 7.65099 9 7.04517 9.23959 6.76464C9.44749 6.52123 9.75934 6.39206 10.0785 6.41717C10.4462 6.44612 10.8746 6.8745 11.7314 7.73125L14.8686 10.8685Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M14.8686 10.8688C15.2646 11.2648 15.4627 11.4628 15.5368 11.6911C15.6021 11.8919 15.6021 12.1083 15.5368 12.3091C15.4627 12.5375 15.2646 12.7355 14.8686 13.1315L11.7314 16.2688C10.8746 17.1255 10.4462 17.5539 10.0785 17.5828C9.75934 17.6079 9.44749 17.4788 9.23959 17.2354C9 16.9548 9 16.349 9 15.1374L9 8.86286C9 7.65123 9 7.04542 9.23959 6.76489C9.44749 6.52148 9.75934 6.3923 10.0785 6.41742C10.4462 6.44636 10.8746 6.87474 11.7314 7.73149L14.8686 10.8688Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 6L14 10M16 12L10 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 6L16 12L10 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M14.8686 10.8685C15.2646 11.2645 15.4627 11.4625 15.5368 11.6909C15.6021 11.8917 15.6021 12.1081 15.5368 12.3089C15.4627 12.5372 15.2646 12.7352 14.8686 13.1312L11.7314 16.2685C10.8746 17.1253 10.4462 17.5536 10.0785 17.5826C9.75934 17.6077 9.44749 17.4785 9.23959 17.2351C9 16.9546 9 16.3488 9 15.1371L9 8.86262C9 7.65099 9 7.04517 9.23959 6.76464C9.44749 6.52123 9.75934 6.39206 10.0785 6.41717C10.4462 6.44612 10.8746 6.8745 11.7314 7.73125L14.8686 10.8685Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
